import React, { useState } from 'react';
import './Career.css';

const Career = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [applicationData, setApplicationData] = useState({
    name: '',
    email: '',
    phone: '',
    position: '',
    experience: '',
    coverLetter: '',
    resume: null
  });
  
const [errors, setErrors] = useState({});
  const jobOpenings = [
    {
      id: 1,
      title: 'Voice sales',
      department: 'Sales',
      location: 'New York, NY',
      type: 'Full-time',
      experience: '3-5 years',
      salary: '$45,000 - $60,000',
      icon: '📞',
      description: 'We are looking for an experienced telecaller to join our sales team and drive revenue growth through outbound calling campaigns.',
      requirements: [
        'Minimum 3 years of telecalling experience',
        'Excellent communication and persuasion skills',
        'Experience with CRM software',
        'Proven track record of meeting sales targets',
        'Bachelor\'s degree preferred'
      ],
      responsibilities: [
        'Conduct outbound calls to potential customers',
        'Maintain detailed records of customer interactions',
        'Meet or exceed monthly sales targets',
        'Collaborate with team members to optimize strategies',
        'Provide excellent customer service'
      ]
    },
    {
      id: 2,
      title: 'Marketing',
      department: 'Customer Service',
      location: 'Remote',
      type: 'Full-time',
      experience: '1-3 years',
      salary: '$35,000 - $45,000',
      icon: '🎧',
      description: 'Join our customer support team to provide exceptional service and resolve customer inquiries through phone and email.',
      requirements: [
        'Minimum 1 year of customer service experience',
        'Strong problem-solving skills',
        'Excellent verbal and written communication',
        'Ability to work in a fast-paced environment',
        'High school diploma required'
      ],
      responsibilities: [
        'Handle inbound customer calls and emails',
        'Resolve customer issues and complaints',
        'Document customer interactions accurately',
        'Escalate complex issues to supervisors',
        'Maintain high customer satisfaction scores'
      ]
    },
    {
      id: 3,
      title: 'US / UK Accounting',
      department: 'Operations',
      location: 'New York, NY',
      type: 'Full-time',
      experience: '5+ years',
      salary: '$55,000 - $70,000',
      icon: '👥',
      description: 'Lead and manage a team of telecallers while ensuring quality standards and performance targets are met.',
      requirements: [
        'Minimum 5 years of telecalling experience',
        'Previous team leadership experience',
        'Strong analytical and coaching skills',
        'Experience with performance management',
        'Bachelor\'s degree in Business or related field'
      ],
      responsibilities: [
        'Manage and coach a team of 10-15 telecallers',
        'Monitor call quality and provide feedback',
        'Develop training programs and materials',
        'Analyze performance metrics and reports',
        'Collaborate with management on strategy'
      ]
    },
    {
      id: 4,
      title: 'Graphic Designing',
      department: 'Research',
      location: 'Remote',
      type: 'Part-time',
      experience: '2-4 years',
      salary: '$25,000 - $35,000',
      icon: '📊',
      description: 'Conduct market research through phone surveys and data analysis to provide valuable insights to our clients.',
      requirements: [
        'Minimum 2 years of market research experience',
        'Strong analytical and statistical skills',
        'Experience with survey design and implementation',
        'Proficiency in Excel and data analysis tools',
        'Bachelor\'s degree in Marketing or related field'
      ],
      responsibilities: [
        'Design and conduct phone surveys',
        'Analyze survey data and prepare reports',
        'Present findings to clients and stakeholders',
        'Maintain survey quality standards',
        'Collaborate with research team on projects'
      ]
    },
    {
      id: 5,
      title: 'CAD Designing',
      department: 'Research',
      location: 'Remote',
      type: 'Part-time',
      experience: '2-4 years',
      salary: '$25,000 - $35,000',
      icon: '📊',
      description: 'Conduct market research through phone surveys and data analysis to provide valuable insights to our clients.',
      requirements: [
        'Minimum 2 years of market research experience',
        'Strong analytical and statistical skills',
        'Experience with survey design and implementation',
        'Proficiency in Excel and data analysis tools',
        'Bachelor\'s degree in Marketing or related field'
      ],
      responsibilities: [
        'Design and conduct phone surveys',
        'Analyze survey data and prepare reports',
        'Present findings to clients and stakeholders',
        'Maintain survey quality standards',
        'Collaborate with research team on projects'
      ]
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setApplicationData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setApplicationData(prev => ({
      ...prev,
      resume: file
    }));
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleApplicationSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Create FormData object for file upload
    const formData = new FormData();
    formData.append('name', applicationData.name);
    formData.append('email', applicationData.email);
    formData.append('phone', applicationData.phone);
    formData.append('position', applicationData.position);
    formData.append('experience', applicationData.experience);
    formData.append('coverLetter', applicationData.coverLetter);
    
    // Append resume file if it exists
    if (applicationData.resume) {
      formData.append('resume', applicationData.resume);
    }

    try {
      // const response = await fetch('http://localhost:5000/api/career', {
      const response = await fetch('https://staffindai-backend.onrender.com/api/career', {
        method: 'POST',
        body: formData, // No Content-Type header needed as it's set automatically for FormData
      });

      const data = await response.json();
      
      if (response.ok) {
        setSubmitStatus({ success: true, message: 'Application submitted successfully! We will get back to you soon.' });
        setApplicationData({
          name: '',
          email: '',
          phone: '',
          position: '',
          experience: '',
          resume: null,
          coverLetter: ''
        });
      } else {
        setSubmitStatus({ success: false, message: data.message || 'Something went wrong. Please try again.' });
      }
    } catch (error) {
      console.error('Error submitting application:', error);
      setSubmitStatus({ success: false, message: 'Network error. Please check your connection and try again.' });
    } finally {
      setIsSubmitting(false);
    }
    ;
  };

  // form validation 
 const handleApplicationChange = (e) => {
  const { name, value, files } = e.target;

  let newValue = value;
  let errorMessage = "";

  // NAME VALIDATION — only letters & space
  if (name === "name") {
    newValue = value.replace(/[^a-zA-Z\s]/g, "");
    if (newValue.trim().length < 20) {
      errorMessage = "name must be 20 characters";
    }
  }

  // PHONE VALIDATION — only numbers + optional +
  if (name === "phone") {
    newValue = value.replace(/[^0-9+]{12}$/g, "");
    if (newValue.length < 9 || newValue.length > 12) {
      errorMessage = "Enter a valid phone number.";
    }
  }

  // EMAIL VALIDATION
  if (name === "email") {
    newValue = value.replace(/[^a-zA-Z0-9@._-]/g, "");

    // only one @ allowed
    const parts = newValue.split("@");
    if (parts.length > 2) {
      newValue = parts[0] + "@" + parts.slice(1).join("").replace(/@/g, "");
    }

    // proper email check
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (newValue && !emailRegex.test(newValue)) {
      errorMessage = "Enter a valid email address.";
    }
  }

  // FILE
  if (name === "resume") {
    newValue = files[0];
  }

  // update data
  setApplicationData({
    ...applicationData,
    [name]: newValue
  });

  // update error per field
  setErrors({
    ...errors,
    [name]: errorMessage
  });
};


  // validation end 
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle modal form submission here
    console.log('Application submitted:', applicationData);
    alert('Application submitted successfully!');
    setSelectedJob(null);
    setApplicationData({
      name: '',
      email: '',
      phone: '',
      position: '',
      experience: '',
      resume: null,
      coverLetter: ''
    });
  };

  return (
    <div className="career-container">
      {/* Professional Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
          
            <h1 className="hero-title">
              Join Our <span className="highlight-te">Professional</span> Team
            </h1>
            <p className="hero-description">
             Build your career with us and be part of a dynamic team that's shaping the future of outsourcing services. Discover opportunities that match your passion and skills in a professional environment.
            </p>
           <div className="hero-badge">
              <span className="badge-text">We're Hiring</span>
            </div>
          </div>
        </div>
      </div>

      {/* Why Work With Us Section */}
      <div className="benefits-section">
        <div className="section-header">
          <h2 className="section-title">Why Choose Staffing Support India ?</h2>
          <p className="section-description">
            We believe in creating an environment where our team members can thrive, grow, and make a meaningful impact.
          </p>
        </div>

        <div className="benefits-grid">
          <div className="benefit-item">
            <div className="benefit-icon">
              <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="benefit-title">Growth Opportunities
</h3>
            <p className="benefit-description">We offer structured career paths, continuous upskilling, and chances to take on diverse responsibilities — so your role evolves as you do.
</p>
          </div>

          <div className="benefit-item">
            <div className="benefit-icon">
              <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
              </svg>
            </div>
            <h3 className="benefit-title">Global Client Exposure
</h3>
            <p className="benefit-description">Work directly with international brands and clients across industries — expand your perspective, portfolio, and professional network.
</p>
          </div>

          <div className="benefit-item">
            <div className="benefit-icon">
              <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="benefit-title">Team Culture</h3>
            <p className="benefit-description">Experience a collaborative and transparent work environment, where support, mentorship, and a strong sense of belonging come standard.</p>
          </div>

          {/* <div className="benefit-item">
            <div className="benefit-icon">
              <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h3 className="benefit-title">Work-Life Balance</h3>
            <p className="benefit-description">Flexible schedules and remote work options to maintain healthy balance.</p>
          </div> */}
        </div>
      </div>

      {/* Job Opportunities Section */}
      {/* <section className="jobs-section">
        <div className="section-header">
          <h2 className="section-title">Job Opportunities</h2>
          <p className="section-description">
            Explore our current job opportunities and find the perfect role for your career growth.
          </p>
        </div>
        <div className="jobs-grid">
          {jobOpenings.map((job) => (
            <div key={job.id} className="job-card">
              <div className="job-card-header">
                <div className="job-icon-container">
                  <span className="job-emoji">{job.icon}</span>
                </div>
                <div className="job-badge">
                  <span className="job-type-badge">{job.type}</span>
                </div>
              </div>
              <div className="job-content">
                <h3 className="job-title">{job.title}</h3>
                <p className="job-department">{job.department}</p>
                <div className="job-details">
                  <div className="job-detail-item">
                    <svg className="detail-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    </svg>
                    <span>{job.location}</span>
                  </div>
                  <div className="job-detail-item">
                    <svg className="detail-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>{job.experience}</span>
                  </div>
                  <div className="job-detail-item">
                    <svg className="detail-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                    </svg>
                    <span>{job.salary}</span>
                  </div>
                </div>
                <p className="job-description">{job.description}</p>
                <button 
                  className="apply-button"
                  onClick={() => {
                    setSelectedJob(job);
                    setApplicationData({ ...applicationData, position: job.title });
                  }}
                >
                  Apply Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* Current Openings - Direct Application Form */}
      <section className="current-openings-section">
        <div className="section-header">
          <h2 className="section-title">Apply for Current Openings</h2>
          <p className="section-description">
            Ready to join our team? Fill out the application form below and we'll get back to you soon.
          </p>
        </div>
        <div className="direct-application-container">
      <div className="application-form">
  <div className="form-group">
    <label className="form-label">Full Name *</label>
    <input
      type="text"
      name="name"
      value={applicationData.name}
      onChange={handleApplicationChange}
      className="form-input"
      placeholder="Enter your full name"
      required
    />
      {errors.name && <p className="error-text">{errors.name}</p>}

  </div>

  <div className="form-group">
    <label className="form-label">Email Address *</label>
    <input
      type="email"
      name="email"
      value={applicationData.email}
      onChange={handleApplicationChange}
      className="form-input"
      placeholder="Enter your email address"
      required
    />
      {errors.email && <p className="error-text">{errors.email}</p>}

  </div>

  <div className="form-group">
    <label className="form-label">Phone Number with Country Code *</label>
    <input
      type="number"
      name="phone"
      value={applicationData.phone}
      onChange={handleApplicationChange}
      className="form-input"
      placeholder="e.g. +91 9876543210"
      required
    />
      {errors.phone && <p className="error-text">{errors.phone}</p>}

  </div>

  <div className="form-group">
    <label className="form-label">Position Applied For *</label>
    <select
      name="position"
      value={applicationData.position}
      onChange={handleApplicationChange}
      className="form-input"
      required
    >
      <option value="">Select a position</option>
      {jobOpenings.map((job) => (
        <option key={job.id} value={job.title}>
          {job.title}
        </option>
      ))}
    </select>
  </div>

  <div className="form-group">
    <label className="form-label">Years of Experience *</label>
    <select
      name="experience"
      value={applicationData.experience}
      onChange={handleApplicationChange}
      className="form-input"
      required
    >
      <option value="">Select experience level</option>
      <option value="0-1 years">0-1 years</option>
      <option value="1-3 years">1-3 years</option>
      <option value="3-5 years">3-5 years</option>
      <option value="5+ years">5+ years</option>
    </select>
  </div>

  <div className="form-group">
    <label className="form-label">Resume/CV *</label>
    <input
      type="file"
      name="resume"
      onChange={handleApplicationChange}
      className="form-input"
      accept=".pdf,.doc,.docx"
      required
    />
  </div>

  <div className="form-group">
    <label className="form-label">Cover Letter</label>
    <textarea
      name="coverLetter"
      value={applicationData.coverLetter}
      onChange={handleApplicationChange}
      className="form-textarea"
      placeholder="Tell us why you're interested in this position..."
      rows="4"
    />
  </div>

  <div className="form-actions">
    {submitStatus && (
      <div className={`form-status ${submitStatus.success ? "success" : "error"}`}>
        {submitStatus.message}
      </div>
    )}

    <button
      type="submit"
      className="submit-button"
      onClick={handleApplicationSubmit}
      disabled={isSubmitting}
    >
      {isSubmitting ? "Submitting..." : "Submit Application"}
    </button>
  </div>
</div>

        </div>
      </section>

      {/* Application Modal */}
      {selectedJob && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title">Apply for {selectedJob.title}</h2>
                <button
                  onClick={() => setSelectedJob(null)}
                  className="close-button"
                >
                  <svg className="close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              <div className="modal-body">
                {/* Job Details */}
                <div className="job-details-section">
                  <h3 className="subsection-title">Job Details</h3>
                  <div className="job-info">
                    <div className="info-section">
                      <h4 className="info-title">Requirements:</h4>
                      <ul className="info-list">
                        {selectedJob.requirements.map((req, index) => (
                          <li key={index}>{req}</li>
                        ))}
                      </ul>
                    </div>
                    <div className="info-section">
                      <h4 className="info-title">Responsibilities:</h4>
                      <ul className="info-list">
                        {selectedJob.responsibilities.map((resp, index) => (
                          <li key={index}>{resp}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                
                {/* Application Form */}
                <div className="application-form-section">
                  <h3 className="subsection-title">Application Form</h3>
                  <form onSubmit={handleApplicationSubmit} className="application-form">
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        value={applicationData.name}
                        onChange={handleApplicationChange}
                        className="form-input"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={applicationData.email}
                        onChange={handleApplicationChange}
                        className="form-input"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="phone" className="form-label">
                        Phone Number *
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        required
                        value={applicationData.phone}
                        onChange={handleApplicationChange}
                        className="form-input"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="experience" className="form-label">
                        Years of Experience *
                      </label>
                      <select
                        id="experience"
                        name="experience"
                        required
                        value={applicationData.experience}
                        onChange={handleApplicationChange}
                        className="form-input"
                      >
                        <option value="">Select experience</option>
                        <option value="0-1">0-1 years</option>
                        <option value="1-3">1-3 years</option>
                        <option value="3-5">3-5 years</option>
                        <option value="5+">5+ years</option>
                      </select>
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="resume" className="form-label">
                        Resume *
                      </label>
                      <input
                        type="file"
                        id="resume"
                        name="resume"
                        required
                        accept=".pdf,.doc,.docx"
                        onChange={handleApplicationChange}
                        className="form-input"
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="coverLetter" className="form-label">
                        Cover Letter *
                      </label>
                      <textarea
                        id="coverLetter"
                        name="coverLetter"
                        required
                        rows={4}
                        value={applicationData.coverLetter}
                        onChange={handleApplicationChange}
                        className="form-textarea"
                        placeholder="Tell us why you're interested in this position..."
                      ></textarea>
                    </div>
                    
                    <div className="form-actions">
                      <button
                        type="button"
                        onClick={() => setSelectedJob(null)}
                        className="cancel-button"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="submit-button"
                      >
                        Submit Application
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Career;